const DEMO_FORM_HASH = "#demo-form";
const FALLBACK_HEADER_HEIGHT_PX = 88;
const TALL_FORM_GAP_PX = 16;

function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function getHeaderHeight(navElement) {
  return (
    navElement?.getBoundingClientRect().height ?? FALLBACK_HEADER_HEIGHT_PX
  );
}

function getTargetTop(demoForm, headerHeight) {
  const formRect = demoForm.getBoundingClientRect();
  const availableHeight = window.innerHeight - headerHeight;
  const formTop = formRect.top + window.scrollY;

  if (formRect.height >= availableHeight) {
    return formTop - headerHeight - TALL_FORM_GAP_PX;
  }

  return formTop - headerHeight - (availableHeight - formRect.height) / 2;
}

function scrollDemoFormIntoView({ behavior, navElement, updateHash }) {
  const demoForm = document.getElementById("demo-form");
  if (!demoForm) return;

  const headerHeight = getHeaderHeight(navElement);
  const targetTop = getTargetTop(demoForm, headerHeight);

  window.scrollTo({
    top: Math.max(0, targetTop),
    behavior,
  });

  if (updateHash && window.location.hash !== DEMO_FORM_HASH) {
    window.history.pushState(null, "", DEMO_FORM_HASH);
  }
}

export function scheduleDemoFormScroll({
  navElement = null,
  updateHash = true,
} = {}) {
  const initialBehavior = prefersReducedMotion() ? "auto" : "smooth";

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollDemoFormIntoView({
        behavior: initialBehavior,
        navElement,
        updateHash,
      });

      window.setTimeout(() => {
        scrollDemoFormIntoView({
          behavior: "auto",
          navElement,
          updateHash,
        });
      }, 450);

      window.setTimeout(() => {
        scrollDemoFormIntoView({
          behavior: "auto",
          navElement,
          updateHash,
        });
      }, 1000);
    });
  });
}

export function isDemoFormHash() {
  return window.location.hash === DEMO_FORM_HASH;
}
